export const EventNames = {
  SWAP_CTA_CLICKED: 'SWAP_CTA_CLICKED',
  QUOTE_ERROR: 'QUOTE_ERROR',
  SWAP_ERROR: 'SWAP_ERROR',
  SWAP_INPUT_FOCUSED: 'SWAP_INPUT_FOCUSED',
  SWAP_OUTPUT_FOCUSED: 'SWAP_OUTPUT_FOCUSED',
  SWAP_ADDRESS_MODAL_CLICKED: 'SWAP_ADDRESS_MODAL_CLICKED',
  SWAP_SWITCH_NETWORK: 'SWAP_SWITCH_NETWORK',
  QUOTE_REQUESTED: 'QUOTE_REQUESTED',
  QUOTE_RECEIVED: 'QUOTE_RECEIVED',
  SWAP_SLIPPAGE_TOLERANCE_SET: 'SWAP_SLIPPAGE_TOLERANCE_SET',
  DEPOSIT_ADDRESS_MODAL_OPEN: 'DEPOSIT_ADDRESS_MODAL_OPEN',
  DEPOSIT_ADDRESS_MODAL_CLOSED: 'DEPOSIT_ADDRESS_MODAL_CLOSED',
  DEPOSIT_ADDRESS_SWAP_ERROR: 'DEPOSIT_ADDRESS_SWAP_ERROR',
  SWAP_MODAL_OPEN: 'SWAP_MODAL_OPEN',
  SWAP_MODAL_CLOSED: 'SWAP_MODAL_CLOSED',
  SWAP_START_TOKEN_SELECT: 'SWAP_START_TOKEN_SELECT',
  SWAP_TOKEN_SELECT: 'SWAP_TOKEN_SELECT',
  SWAP_EXIT_TOKEN_SELECT: 'SWAP_EXIT_TOKEN_SELECT',
  DEPOSIT_SUBMITTED: 'DEPOSIT_SUBMITTED',
  APPROVAL_SUBMITTED: 'APPROVAL_SUBMITTED',
  APPROVAL_SUCCESS: 'APPROVAL_SUCCESS',
  APPROVAL_ERROR: 'APPROVAL_ERROR',
  DEPOSIT_SUCCESS: 'DEPOSIT_SUCCESS',
  DEPOSIT_ERROR: 'DEPOSIT_ERROR',
  BATCH_TX_SUBMITTED: 'BATCH_TX_SUBMITTED',
  FILL_SUCCESS: 'FILL_SUCCESS',
  FILL_ERROR: 'FILL_ERROR',
  SWAP_SUCCESS: 'SWAP_SUCCESS',
  SWAP_ROUTE_SELECTED: 'SWAP_ROUTE_SELECTED',
  TOKEN_SELECTOR_CONTRACT_SEARCH: 'TOKEN_SELECTOR_CONTRACT_SEARCH',
  CTA_SET_MAX_CAPACITY_CLICKED: 'CTA_SET_MAX_CAPACITY_CLICKED',
  CTA_SWITCH_ROUTE_CLICKED: 'CTA_SWITCH_ROUTE_CLICKED',
  CTA_MAX_CAPACITY_PROMPTED: 'CTA_MAX_CAPACITY_PROMPTED',
  WALLET_SELECTOR_SELECT: 'WALLET_SELECTOR_SELECT',
  WALLET_SELECTOR_OPEN: 'WALLET_SELECTOR_OPEN',
  WALLET_SELECTOR_CLOSE: 'WALLET_SELECTOR_CLOSE',
  MAX_AMOUNT_CLICKED: 'MAX_AMOUNT_CLICKED',
  CURRENCY_STEP_CHAIN_FILTER: 'CURRENCY_STEP_CHAIN_FILTER',
  UNVERIFIED_TOKEN_ACCEPTED: 'UNVERIFIED_TOKEN_ACCEPTED',
  ONRAMP_MODAL_OPEN: 'ONRAMP_MODAL_OPEN',
  ONRAMP_MODAL_CLOSE: 'ONRAMP_MODAL_CLOSE',
  ONRAMP_CTA_CLICKED: 'ONRAMP_CTA_CLICKED',
  ONRAMPING_MOONPAY_TX_START: 'ONRAMPING_MOONPAY_TX_START',
  ONRAMPING_MOONPAY_TX_COMPLETE: 'ONRAMPING_MOONPAY_TX_COMPLETE',
  ONRAMPING_MOONPAY_TX_FAILED: 'ONRAMPING_MOONPAY_TX_FAILED',
  ONRAMPING_MOONPAY_TX_API_ERROR: 'ONRAMPING_MOONPAY_TX_API_ERROR',
  ONRAMP_SUCCESS: 'ONRAMP_SUCCESS',
  ONRAMP_ERROR: 'ONRAMP_ERROR',
  ONRAMP_PASSTHROUGH_SUCCESS: 'ONRAMP_PASSTHROUGH_SUCCESS',
  GAS_TOP_UP_TOGGLE: 'GAS_TOP_UP_TOGGLE',
  AGW_CHECK_ERROR: 'AGW_CHECK_ERROR',
  CHAIN_STARRED: 'CHAIN_STARRED',
  CHAIN_UNSTARRED: 'CHAIN_UNSTARRED',
  //Common
  USER_REJECTED_WALLET: 'USER_REJECTED_WALLET',
  CONNECT_WALLET_CLICKED: 'CONNECT_WALLET_CLICKED',
  TRANSACTION_VALIDATING: 'TRANSACTION_VALIDATING',
  ADDRESS_MODAL_OPEN: 'ADDRESS_MODAL_OPEN',
  ADDRESS_MODAL_CONFIRMED: 'ADDRESS_MODAL_CONFIRMED'
}
